var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"light":""}},[_c('v-main',{staticClass:"bg-[#f0f4f7]"},[_c('router-view'),_c('SnackBar'),_c('LoadingState')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }